export default {
  message: {
    Tour: {
      continue: "Continue",
      back: "Back",
      finish: "Finish"
    },
    Login: {
      title: "Parent sign in",
      sign_in: "Sign in",
      login_fail:
        "Authentication Failed. Please try again or contact your school for help signing in.",
      forgot_password: "Forgot Password",
      create_account: "Create Account",
      password: "Password",
      confirm_password: "Confirm Password",
      password_reminder: "Password Reminder",
      enter_email: "Enter your email address",
      validation_error: "Validation Error Message",
      password_reminder_error_no_user_register:
        "The username you entered could not be found. Please try again or create a new account.",
      password_reminder_error_no_user: "The username you entered could not be found.",
      password_reminder_sent: "An email with further instructions has been sent to {email}.",
      password_reminder_sent_message:
        "The email may take a few minutes to arrive. If you don't see it in your inbox, check your spam folder.",
      password_trouble_email: "If you are still having trouble, please contact {email}.",
      password_trouble_school:
        "If you are still having trouble, please contact your school for help.",
      return_to_sign_in: "Return to Sign In",
      create_my_account: "Create my account",
      or_sign_in_with: "OR SIGN IN WITH",
      password_reset: "Please choose a new password for your account.",
      password_reset_warning:
        "If you did not request to change your password, then please contact your school administrator immediately.",
      password_update: "Choose New Password",
      password_update_confirm: "Confirm New Password",
      password_update_success: "Your new password has been saved."
    },
    AccountSettings: {
      title: "Account Settings",
      first_name: "First Name",
      last_name: "Last Name",
      email: "Email",
      username: "Username",
      password: "Password",
      students: "Students",
      teachers: "Teachers",
      external_id: "External ID",
      phone: "Phone Number",
      phone_required: "Phone number is required",
      edit: "Edit",
      remove: "Remove",
      add: "Add",
      remove_message: "Are you sure you want to remove this student name?",
      yes: "Yes",
      no: "No",
      add_student: "Add Student",
      close: "Close",
      save: "Save Changes",
      cancel: "Cancel",
      student_alert_message: "You must enter at least one student.",
      logout: "Log Out"
    },
    TrialStatus: {
      title: "Update Trial Status",
      schoolLabel: "School",
      currentStatus: "Current Status",
      newStatus: "New Status",
      updatedSuccess: "Trial status updated successfully",
      updateError: "Failed to update trial status",
      statuses: {
        requested: "Requested",
        pending: "Pending",
        fullfilled: "Fulfilled",
        expired: "Expired",
        cancelled: "Cancelled",
        rejected: "Rejected",
        converted: "Converted"
      }
    },
    Navbar: {
      my_meetings: "My Meetings",
      language: "English",
      help: "Help",
      account_settings: "Account Settings",
      user_management: "User Management",
      logout: "Log Out"
    },
    SubNavbar: {
      meeting: "Meeting",
      event: "Event",
      print: "Print",
      email: "Email",
      export: "Export"
    },
    ConferenceCard: {
      add_edit_meetings: "Add/Edit Meetings",
      opening: "Opening",
      closed: "Closed"
    },
    Agenda: {
      full_agenda: "Full Agenda",
      empty_state_title: "We couldn't find any conferences for you.",
      empty_state_message: "If you have any questions, please contact your school representative.",
      confirmation_modal_title: "Agenda Confirmed",
      confirmation_modal_message:
        "Your agenda has been successfully confirmed and an email has been sent to you.",
      complete_button: "Finished!"
    },
    AgendaCard: {
      room: "Room Unavailable",
      room_with_value: "Room: {room}",
      virtual_meeting: "Virtual Meeting",
      all_conferences: "All Conferences",
      conference: "Conference",
      student: "Student",
      meeting_with: "Meeting With",
      date_time: "Date/Time",
      meeting_type: "Meeting Type",
      location: "Location",
      comment: "Comment",
      action: "Action",
      delete: "Delete",
      add_comment: "Add Comment",
      join: "Join Meeting",
      choose_meeting_type: "Choose meeting type",
      in_person: "In Person",
      phone: "Phone",
      callback: "Callback",
      virtual: "Virtual",
      hybrid: "Hybrid",
      unavailable: "Not Available",
      tooltip_translator:
        "Translator service is not guaranteed but the school will make every effort to ensure it is available.",
      translator_requested: "Translator requested",
      clear_translator: "Clear translator request",
      need_translator: "Need a translator?",
      choose_language: "Choose a language"
    },
    ScheduleMatrix: {
      no_teachers_title: "No teachers or teams are selected.",
      no_teachers_message: "Please choose a teacher in order to view their meeting times.",
      choose_teachers_button: "View available teachers or teams",
      choose_student: "For which student?",
      cancel: "Cancel"
    },
    Matrix: {
      teachers: "Teachers",
      agenda: "Review and Continue"
    },
    DrawerTeachers: {
      teachers: "Teachers",
      name: "Name",
      description: "Description",
      student: "Student",
      teacher_team: "Teacher/Team",
      show_more: "Show More Teachers",
      show_all: "Show all the teachers in the school",
      selected: "({count}) selected",
      closeDrawer: "Continue to schedule",
      search: "Search for a teacher or team",
      not_available: "This teacher does not have any available meeting times on {date}."
    },
    DrawerAgenda: {
      no_meetings_title: "You have no meetings scheduled.",
      no_meetings_message: "Once you've chosen a teacher and a timeslot, it will appear here.",
      new_meeting_label: "New",
      cancel_button: "Cancel",
      student_label: "Student",
      meeting_type_location: "Meeting Type/Location",
      comment_label: "Comment",
      save_comment_button: "Save comment",
      confirm_label: "Please confirm:",
      confirm_cancel_button: "Yes, cancel my meeting with ",
      do_not_cancel_button: "Don't cancel",
      confirm_agenda_button: "Confirm this agenda",
      confirm_agenda_message_line1: "You can always return and make changes.",
      confirm_agenda_message_line2: "Your current agenda will be emailed to you."
    },
    EmailConsent: {
      message:
        "In an effort to protect your privacy and security, we need you to consent to receive communication from our system to your email address.",
      consent: "Consent"
    },
    UserManagement: {
      pageTitle: "User Management",
      pageSubtitle:
        "Add and manage school and district staff accounts. Staff sign in with school or district login using this site’s account.",
      addUser: "Add user",
      editUser: "Edit user",
      loading: "Loading users…",
      emptyTitle: "No staff users yet",
      emptyMessage: "Use Add user to create a school or district staff account.",
      tableUsername: "Username",
      tableEmail: "Email",
      tableRole: "Role",
      tableActions: "Actions",
      typeSchool: "School",
      typeDistrict: "District",
      roleTeam: "Team",
      roleSchool: "School Admin",
      roleReporter: "School Reporter",
      roleDistrict: "District Admin",
      roleNoIntegration: "School Admin without Integration",
      roleNotSet: "Role not set",
      roleUnknown: "Role ({id})",
      formUsername: "Username",
      formEmail: "Email",
      formPassword: "Password",
      formNewPassword: "New password (optional)",
      formRole: "Role",
      loginHint:
        "Staff sign in with the school portal. District staff may use the district portal subdomain when applicable.",
      save: "Save",
      cancel: "Cancel",
      edit: "Edit",
      delete: "Delete",
      confirmDeleteTitle: "Remove this user?",
      confirmDeleteBody:
        "This will remove the staff account from your school. This action cannot be undone.",
      validationRequired: "Please fill in all required fields.",
      createdSuccess: "User created.",
      updatedSuccess: "User updated.",
      deletedSuccess: "User removed.",
      genericError: "Something went wrong. Please try again.",
      changeRoleTitle: "Change role",
      roleUpdatedSuccess: "Role updated.",
      deleteUserAria: "Remove user",
      formSchool: "School",
      validationSchoolRequired: "Please select a school.",
      schoolListEmpty: "No schools are available in this district."
    },
    StudentsDirectory: {
      saveLinkHousehold: "Save link household",
      saveLinkHouseholdNothing: "No changes to save.",
      saveLinkHouseholdSuccess: "Link household updated for {count} students.",
      saveLinkHouseholdError: "Could not update link household.",
      saveLinkHouseholdPartial: "Updated {saved} students; {failed} could not be saved."
    }
  }
};
